exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".riskhub-logo{height:50px;width:50px;margin-left:2.2em;margin-top:.5em}", ""]);

// exports
